/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, QueryParams, SendRequestPayload } from '../baseClient';
import { 
  CorePayeeRelationshipCurrentRelationshipsParams,
  CorePayeeRelationshipUnclaimedRelationshipsParams,
  CorePayeeRelationshipTakeControlInfoParams,
  UpdateRelationshipRequest2,
  SendVerificationByContactMethodTokenRequest,
  SendVerificationTokenRequest,
  ClaimRelationshipsRequest,
  ClaimRelationshipsForContactMethodRequest,
  ClaimRelationshipWithoutVerificationRequest,
  ClaimRelationshipRequest,
  UpdateRelationshipUnauthenticatedRequest,
  CreateClaimIntentRequest,
  CurrentRelationshipsResponse,
  CurrentRelationshipResponse,
  UnclaimedRelationshipsResponse,
  RelationshipIdsByContactInfoDto,
  SuccessResponse,
  TermsOfServiceResponse,
  ActivePromotionalCampaignResponse,
  ListPayeePromotionalInvoicesByCampaignResponse,
  ClaimRelationshipResponse,
  FactorMarketingPageResponse
 } from '../types';

  //  CorePayeeRelationshipClient
class CorePayeeRelationshipClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly currentRelationships = (queryParams: CorePayeeRelationshipCurrentRelationshipsParams): AxiosPromise<CurrentRelationshipsResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly currentRelationship = (id: string): AxiosPromise<CurrentRelationshipResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly updateRelationship = (id: string, payload: UpdateRelationshipRequest2): AxiosPromise<CurrentRelationshipResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly unclaimedRelationships = (queryParams: CorePayeeRelationshipUnclaimedRelationshipsParams): AxiosPromise<UnclaimedRelationshipsResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/unclaimed_relationships";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly relationshipsByContactInfo = (): AxiosPromise<RelationshipIdsByContactInfoDto[]> => {
        let url_ = "/api/v1/core/payee/payee_relationships/contact_info";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly sendVerificationTokenByContactMethod = (payload: SendVerificationByContactMethodTokenRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/verify_payee_contact_method";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly sendVerificationToken = (id: string, payload: SendVerificationTokenRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}/verify";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly termsOfService = (id: string): AxiosPromise<TermsOfServiceResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}/terms";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly activePromotionalCampaign = (id: string): AxiosPromise<ActivePromotionalCampaignResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}/promotional_campaign";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly promotionalInvoices = (id: string): AxiosPromise<ListPayeePromotionalInvoicesByCampaignResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}/promotional_invoices";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly claimRelationships = (payload: ClaimRelationshipsRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/claim";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly claimRelationshipsForContactMethod = (payload: ClaimRelationshipsForContactMethodRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/claim_for_contact_method";

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly claimRelationshipWithoutVerification = (id: string, payload: ClaimRelationshipWithoutVerificationRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}/claim_without_verification";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly claimRelationship = (id: string, payload: ClaimRelationshipRequest): AxiosPromise<ClaimRelationshipResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}/claim";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly updateRelationshipUnauthenticated = (id: string, payload: UpdateRelationshipUnauthenticatedRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}/unauthenticated_request";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "PUT",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly takeControlInfo = (id: string, queryParams: CorePayeeRelationshipTakeControlInfoParams): AxiosPromise<FactorMarketingPageResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}/take_control_info";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly createClaimIntent = (id: string, payload: CreateClaimIntentRequest): AxiosPromise<SuccessResponse> => {
        let url_ = "/api/v1/core/payee/payee_relationships/{id}/create_claim_intent";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const sendRequestPayload: SendRequestPayload = {
            data: payload,
            method: "POST",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CorePayeeRelationshipClient
  
export const corePayeeRelationshipClient = new CorePayeeRelationshipClient(baseClientConstructorProps);
